import { ExpensesTable } from "components";

const Expenses = () => {

    return (
        <ExpensesTable />
    );

}
export default Expenses;